// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__QB-WJ","header":"ClearentDisclaimer_header__37VPT","inner":"ClearentDisclaimer_inner__34uDk"};